import { UrlHandlingStrategy, UrlSegment, UrlTree } from '@angular/router';
import { I18nService } from '../services';
import { lmExclusions } from './languageMarketExclusions';

export class LanguageUrlStrategy implements UrlHandlingStrategy {
  service: I18nService = I18nService.prototype;
  currentLanguage: string = '';

  shouldProcessUrl(): boolean {
    return true;
  }

  extract(url: UrlTree): UrlTree {
    return this.replaceTildeInUrlTree(url);
  }

  merge(newUrlPart: UrlTree): UrlTree {
    const reg: RegExp = /^[a-z]{2}-[a-z]{2,3}$/;
    if (!newUrlPart.root.children.primary) {
      return newUrlPart;
    }
    const firstSegmentPath: string = newUrlPart.root.children.primary.segments[0].path;
    if (reg.exec(firstSegmentPath)) {
      if (!this.currentLanguage) {
        this.currentLanguage = firstSegmentPath;
      }
      if (firstSegmentPath !== this.currentLanguage) {
        this.currentLanguage = firstSegmentPath;
      }
    } else {
      const is404: number = newUrlPart.root.children.primary.segments.findIndex(s => s.path === 'page-not-found');
      if (is404 !== -1) {
        this.currentLanguage = this.service.getCurrentParam();
      }
      if (!lmExclusions.includes(firstSegmentPath)) {
        newUrlPart.root.children.primary.segments.splice(0, 0,
          new UrlSegment(this.currentLanguage || this.service.getCurrentParam(), {}));
      }
    }
    return newUrlPart;
  }

  /**
   * Replaces all occurrences of ~ with - in the primary segments of the UrlTree.
   * @param {UrlTree} urlTree
   * @returns {UrlTree}
   * @private
   */
  private replaceTildeInUrlTree(urlTree: UrlTree): UrlTree {
    if (urlTree.root.children?.primary?.segments) {
      const primarySegments: UrlSegment[] = urlTree.root.children.primary.segments.map(segment =>
        new UrlSegment(segment.path.replaceAll('~', '-'), segment.parameters)
      );
      urlTree.root.children.primary.segments = primarySegments;
      return urlTree;
    } else return urlTree;
  }
}
